module.exports = {"available":"Szabad","booked":"Foglalt","occupied":"Occupied","booked-occupied":"Foglalt / Occupied","used":"used","until":"ig","all-day":"egész nap","page_over_total":"Oldal {page} -ből {total}","room-name":"Tárgyaló neve","current-booking":"Aktuális","next-booking":"Következő","unknown":"Ismeretlen","floors":"szintek","today":"ma","no_bookings":"Nincs tervezett megbeszélés mára","no_information":"Nem áll rendelkezésre információ","description":"Description","capacity":"Capacity","allocated":"Allocated","booked-occupied-allocated":"Foglalt / Occupied / Allocated"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/hu.json
// module id = stas
// module chunks = 2